import * as _ from 'lodash'
import moment from 'moment'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
// import 'bootstrap-datepicker'
// import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css'
import ApexCharts from 'apexcharts'
import 'apexcharts/dist/apexcharts.css'

const meta = 'report_income_expenses'
window[`fnc_${meta}`] = initReportIncExpPage

document.addEventListener("loadPage", () => {
    const evMeta = document.querySelector('meta[name="eventListener"]')
    if (evMeta !== null && evMeta['content'] === meta) {
        document.addEventListener("appReady", () => {
            if (DEBUG) console.log((`Initializing ${meta} page`))
            window[`fnc_${meta}`]()
        })
    }
})


async function initReportIncExpPage() {
    $('#loading-animation').removeClass('visually-hidden')
    $('.row.widget-container').each(function (idx, obj) {
        $(this).addClass('visually-hidden')
    })

    $('.wval').each(function(idx, obj) {
        $(this).text('--')
    })

    const period = helpers.appSettingsGet('reportPeriodIE') !== null ? moment(helpers.appSettingsGet('reportPeriodIE')).toISOString() : moment().toISOString()

    const options1: Intl.DateTimeFormatOptions = {
        month: "long",
        year: 'numeric'
    }

    const options2: Intl.DateTimeFormatOptions = {
        year: 'numeric'
    }
    
    $('#dashboard-period').text(helpers.ucFirst( new Intl.DateTimeFormat(globals.vars.locales, options1).format(new Date(period)) ))
    $('#report-widget-m').text(helpers.ucFirst( new Intl.DateTimeFormat(globals.vars.locales, options1).format(new Date(period)) ))
    $('#report-widget-l').text(helpers.ucFirst( new Intl.DateTimeFormat(globals.vars.locales, options1).format(new Date(moment(period).subtract(1, 'month').toISOString())) ))
    $('#report-widget-y').text(helpers.ucFirst( new Intl.DateTimeFormat(globals.vars.locales, options2).format(new Date(period)) ))

    if (moment(period).endOf('month') < moment()) {
        $('#period-next').removeAttr('disabled')
        $('#period-reset').removeClass('visually-hidden')
    } else {
        $('#period-next').attr('disabled')
        $('#period-reset').addClass('visually-hidden')
    }
    
    $('#period-prev').off().on('click', function(e) {
        helpers.appSettingsSet({'reportPeriodIE': moment(period).subtract(1, 'month').toISOString()})
        setTimeout(initReportIncExpPage, 100)
    })
    
    $('#period-next').off().on('click', function(e) {
        helpers.appSettingsSet({'reportPeriodIE': moment(period).add(1, 'month').toISOString()})
        setTimeout(initReportIncExpPage, 100)
    })
    
    $('#period-reset').off().on('click', function(e) {
        helpers.appSettingsDelete('reportPeriodIE')
        setTimeout(initReportIncExpPage, 100)
    })

    const prevAccounts = helpers.appSettingsGet('reportSelectedAccount') || 'all_accounts'

    let accounts: object[] = []

      if (prevAccounts == 'all_accounts') {
        accounts = _.filter(globals.vars.userData.accounts, function(o) {
            return o['archived'] === false && o['statistic'] === true
        })
    } else if (prevAccounts == 'all_favorites') {
        accounts = _.filter(globals.vars.userData.accounts, function(o) {
            return o['archived'] === false && o['statistic'] === true && o['favorite'] === true
        })
    } else {
        accounts = _.filter(globals.vars.userData.accounts, function(o) {
            return o['archived'] === false && o['_id'] === prevAccounts
        })        
    }

    if (accounts.length == 0) {
        accounts = _.filter(globals.vars.userData.accounts, function(o) {
            return o['archived'] === false && o['statistic'] === true
        })
    }
        
    $('#report-account').val(prevAccounts)

    $('#report-account').off().on('change', function(e) {
        helpers.appSettingsSet({'reportSelectedAccount': $('#report-account').val() as string})
        setTimeout(initReportIncExpPage, 100)
    })
 
    const params = {
        accounts: _.map(accounts, function(o) { return o['_id']}),
        sMonth: moment(period).toISOString(),
        _csrf: $("meta[name=_csrf]").attr("content")
    }

    $.ajax({
        url: '/json/reports/income-expenses',
        method: 'POST',
        data: params,
        success: function (response) {  
            if (DEBUG) console.log(response)

            setTimeout(function() {
                drawSavingsGauge(response['revenues']['this_month'])
                drawRevenuesBarChart(response['revenues']['savings'])
                drawDonutIncome(response['categories'])
                drawDonutExpenses(response['categories'])
            }, 250)
    
            //ANCHOR WIDGETS
            if (typeof response['revenues']['this_month'] !== 'undefined') {    
                if (!isNaN(response['revenues']['this_month']['income']))
                    $('#stats-mi').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_month']['income'], 'EUR') ))

                if (!isNaN(response['revenues']['this_month']['expenses']))
                    $('#stats-me').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_month']['expenses'], 'EUR') ))

                if (!isNaN(response['revenues']['this_month']['profit'])) {
                    $('#stats-mr').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_month']['profit'], 'EUR') ))

                    if (parseFloat(response['revenues']['this_month']['profit']) >= 0)
                        $('#stats-mr').removeClass('text-danger').addClass('text-success')
                    else
                        $('#stats-mr').removeClass('text-success').addClass('text-danger')
                }
            }

            if (typeof response['revenues']['last_month'] !== 'undefined') {   
                if (!isNaN(response['revenues']['last_month']['income']))
                    $('#stats-mdi').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['last_month']['income'], 'EUR') ))

                if (!isNaN(response['revenues']['last_month']['expenses']))
                    $('#stats-mde').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['last_month']['expenses'], 'EUR') ))

                if (!isNaN(response['revenues']['last_month']['profit'])) {
                    $('#stats-mdr').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['last_month']['profit'], 'EUR') ))

                    if (parseFloat(response['revenues']['last_month']['profit']) >= 0)
                        $('#stats-mdr').removeClass('text-danger').addClass('text-success')
                    else
                        $('#stats-mdr').removeClass('text-success').addClass('text-danger')
                }
            }         

            if (typeof response['revenues']['this_year'] !== 'undefined') {   
                if (!isNaN(response['revenues']['this_year']['income']))
                    $('#stats-yi').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_year']['income'], 'EUR') ))

                if (!isNaN(response['revenues']['this_year']['expenses']))
                    $('#stats-ye').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_year']['expenses'], 'EUR') ))

                if (!isNaN(response['revenues']['this_year']['profit'])) {
                    $('#stats-yr').text(helpers.anonFigures( helpers.fmtCurrency(response['revenues']['this_year']['profit'], 'EUR') ))

                    if (parseFloat(response['revenues']['this_year']['profit']) >= 0)
                        $('#stats-yr').removeClass('text-danger').addClass('text-success')
                    else
                        $('#stats-yr').removeClass('text-success').addClass('text-danger')
                }
            }         

           
            const categories = response.categories

            let output = ''
            let total_rev = 0

            let _cSorted = _.orderBy(categories, ['expenses'], ['asc'])

            for (let i=0; i<_cSorted.length; i++) {
                const _cat = _cSorted[i]

                if (_cat['expenses'] == 0)
                    continue

                let _a = helpers.anonFigures( helpers.fmtCurrency(_cat['expenses'], 'EUR') )

                if (_cat['_id']['statistics'] == false)
                    _a = `(${_a})`
                else
                    total_rev += parseFloat(_cat['expenses'])

                const cls = _cat['expenses'] >= 0 ? 'text-success' : 'text-danger'

                const accounts = _.compact(_.map(_cat['accounts'], function(o) {
                    return globals.vars.userData.accountsById[o]['custom_name'] || globals.vars.userData.accountsById[o]['name'] || null
                }))

                const _mark = typeof _cat['_id']['categoryId'] === 'undefined' ? ' bolder text-orange' : ''

                output += `
                        <tr class="d-flex drill-to-tr" data-category="${_cat['_id']['categoryId']}">
                            <th scope="row" class="text-center justify-content-center" style="width: 22px"><i class="${_cat['_id']['icon']}${_mark}" style="height: 20px; width: auto"></i></th>
                            <td class="flex-grow-1 sTitle">${_cat['_id']['name']}</td>
                            <td class="d-flex ${cls} justify-content-end amount fs-5" data-plugin="tippy" data-tippy-placement="left" data-tippy="" data-tippy-allowHTML="true" data-tippy-content="${accounts.sort().join('<br>')}">${_a}</td>
                        </tr>`
            }

            $('#expenses-table').html(output)

            let cls = total_rev >= 0 ? 'text-success' : 'text-danger'
            $('#expenses-rev').text(helpers.anonFigures((total_rev > 0 ? '+' : '')+helpers.fmtCurrency(total_rev, 'EUR') ))
            $('#expenses-rev').addClass(cls)


            output = ''
            total_rev = 0

            _cSorted = _.orderBy(categories, ['income'], ['desc'])

            for (let i=0; i<_cSorted.length; i++) {
                const _cat = _cSorted[i]

                if (_cat['income'] == 0)
                    continue

                let _a = helpers.anonFigures( helpers.fmtCurrency(_cat['income'], 'EUR') )

                if (_cat['_id']['statistics'] == false)
                    _a = `(${_a})`
                else
                    total_rev += parseFloat(_cat['income'])

                const cls = _cat['income'] >= 0 ? 'text-success' : 'text-danger'

                const accounts = _.compact(_.map(_cat['accounts'], function(o) {
                    return globals.vars.userData.accountsById[o]['custom_name'] || globals.vars.userData.accountsById[o]['name'] || null
                }))

                const _mark = typeof _cat['_id']['categoryId'] === 'undefined' ? ' bolder text-orange' : ''

                output += `
                        <tr class="d-flex drill-to-tr" data-category="${_cat['_id']['categoryId']}">
                            <th scope="row" class="text-center justify-content-center" style="width: 22px"><i class="${_cat['_id']['icon']}${_mark}" style="height: 20px; width: auto"></i></th>
                            <td class="flex-grow-1 sTitle">${_cat['_id']['name']}</td>
                            <td class="d-flex ${cls} justify-content-end amount fs-5" data-plugin="tippy" data-tippy-placement="left" data-tippy="" data-tippy-allowHTML="true" data-tippy-content="${accounts.sort().join('<br>')}">${_a}</td>
                        </tr>`
            }

            $('#income-table').html(output)

            tippy('[data-plugin="tippy"]')

            //ANCHOR Category click
            $('.drill-to-tr').each(function (idx, obj) {
                $(this).off().on('dblclick', (e) => {
                    e.preventDefault()

                    window.getSelection().removeAllRanges()
                    
                    helpers.appSettingsSet({'transactionsStartTime': moment(period).startOf('month').toISOString()})
                    helpers.appSettingsSet({'transactionsEndTime': moment(period).endOf('month').toISOString()})
                    helpers.appSettingsDelete('transactionsUntilToday')

                    if ($('#report-account').val() == 'all_accounts') {
                        helpers.appSettingsDelete('transactionsAccountId')
                        helpers.appSettingsSet({'transactionsFavoriteAccountsOnly': false})

                    } else if ($('#report-account').val() == 'all_favorites') {
                        helpers.appSettingsDelete('transactionsAccountId')
                        helpers.appSettingsSet({'transactionsFavoriteAccountsOnly': true})
                    } else {
                        helpers.appSettingsSet({'transactionsFavoriteAccountsOnly': false})
                        helpers.appSettingsSet({'transactionsAccountId': $('#report-account').val()})
                    }

                    if ($(this).closest('tr').attr('data-category') !== 'undefined') {
                        helpers.appSettingsSet({'transactionsCategoryFilter': $(this).closest('tr').attr('data-category')})
                        helpers.appSettingsDelete('transactionsFilters')
                    } else {
                        helpers.appSettingsDelete('transactionsCategoryFilter')
                        helpers.appSettingsSet({'transactionsFilters': ['#filter_uncategorized']})
                    }

                    window.location.href = '/transactions'
                })
            })

            cls = total_rev >= 0 ? 'text-success' : 'text-danger'
            $('#income-rev').text(helpers.anonFigures((total_rev > 0 ? '+' : '')+helpers.fmtCurrency(total_rev, 'EUR') ))
            $('#income-rev').addClass(cls)


            $('#loading-animation').addClass('visually-hidden')
            $('.row.widget-container').each(function (idx, obj) {
                $(this).removeClass('visually-hidden')
            })


        },
        error: function (err) {
            console.log(err)
        }
    })
}

function drawRevenuesBarChart(data) {
    const _income = _.map(data, function(o) {
        return { x: helpers.ucFirst(moment(o['period']).format('MMM').replace(/\./, "")), y: o['income'] }
    })

    const _expenses = _.map(data, function(o) {
        return { x: helpers.ucFirst(moment(o['period']).format('MMM').replace(/\./, "")), y: Math.abs(o['expenses']) }
    })

    const periods = _.map(data, function(o) {
        return helpers.ucFirst(moment(o['period']).format('MMM').replace(/\./, ""))
    })

    var colors = ['#3bafda','#1abc9c', '#CED4DC']
    var dataColors = $("#apex-column-1").data('colors')
    if (dataColors) {
        colors = dataColors.split(",")
    }

    const options = {
        chart: {
            height: 195,
            type: 'bar',
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                endingShape: 'rounded',
                columnWidth: '55%',
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        colors: colors,
        series: [
            {
                name: global.i18n.t('dashboard.widgets.income'),
                data: _income
            },
            {
                name: global.i18n.t('dashboard.widgets.expenses'),
                data: _expenses
            }
        ],
        xaxis: {
            categories: periods,
        },
        legend: {
            show: false,
            offsetY: 5,
        },
        yaxis: {
            decimalsInFloat: 2,
            labels: {
                show: true,
                showDuplicates: false,
                formatter: (value) => { return helpers.anonFigures(helpers.fmtCurrency(value, undefined, 0)) },
            },
            title: {
                text: '',
            }
        },
        fill: {
            opacity: 1
    
        },
        grid: {
            row: {
                colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.2
            },
            borderColor: '#f1f3fa',
            padding: {
                bottom: 10
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return helpers.fmtCurrency(val)
                }
            }
        }
    }
    
    if (typeof globals.vars.charts['apex1'] === 'undefined') {
        globals.vars.charts['apex1'] = new ApexCharts(document.querySelector("#apex-column-1"), options)
        globals.vars.charts['apex1'].render()
    } else {
        globals.vars.charts['apex1'].updateSeries([
            {
                data: _income
            }, {
                data: _expenses
            }
        ], false)

        globals.vars.charts['apex1'].updateOptions({ xaxis: { categories: periods } }, true)   
    }
}


function drawDonutIncome(data) {
    const total_income = _.sumBy(data, function (o) {
        return o['income']
    })
    
    const options = {
        chart: {
            height: 150,
            type: 'donut',
        },
        series: _.map(data, function(o) { return o['income'] / total_income *100 }),
        labels: _.map(data, function(o) { return o['_id']['name'] }),
        theme: {
            palette: 'palette2'
        },
        legend: {
            show: false,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0,
            offsetY: 7
        },
        dataLabels: {
            enabled: false,
            formatter: function (val) {
              return val + "%"
            },
            dropShadow: {
         
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return new Intl.NumberFormat(globals.vars.locales, { minimumFractionDigits: 2, maximumFractionDigits: 2, style: "percent" }).format(val/100)
                }
            }
        },
        title: {
            text: undefined,
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              color:  '#263238'
            },
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 240
                },
                legend: {
                    show: false
                },
            }
        }]

    }

    if (typeof globals.vars.charts['apex2'] === 'undefined') {
        globals.vars.charts['apex2'] = new ApexCharts(document.querySelector("#apex-pie-1"), options)
        globals.vars.charts['apex2'].render()
    } else {
        globals.vars.charts['apex2'].updateSeries(_.map(data, function(o) { return o['income'] / total_income *100 }), true)
        globals.vars.charts['apex2'].updateOptions({ labels: _.map(data, function(o) { return o['_id']['name'] })})       
    }
}



function drawDonutExpenses(data) {
    const total_expenses = _.sumBy(data, function (o) {
        return o['expenses']
    })

    const options = {
        chart: {
            height: 150,
            type: 'donut',
        },
        series: _.map(data, function(o) { return o['expenses'] / total_expenses *100 }),
        labels: _.map(data, function(o) { return o['_id']['name'] }),
        theme: {
            palette: 'palette2'
        },
        legend: {
            show: false,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0,
            offsetY: 7
        },
        dataLabels: {
            enabled: false,
            formatter: function (val) {
              return val + "%"
            },
            dropShadow: {
         
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return new Intl.NumberFormat(globals.vars.locales, { minimumFractionDigits: 2, maximumFractionDigits: 2, style: "percent" }).format(val/100)
                }
            }
        },
        title: {
            text: undefined,
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              color:  '#263238'
            },
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 240
                },
                legend: {
                    show: false
                },
            }
        }]

    }

    if (typeof globals.vars.charts['apex3'] === 'undefined') {
        globals.vars.charts['apex3'] = new ApexCharts(document.querySelector("#apex-pie-2"), options)
        globals.vars.charts['apex3'].render()
    } else {
        globals.vars.charts['apex3'].updateOptions(options, true, true, true)
        globals.vars.charts['apex3'].updateOptions({ labels: _.map(data, function(o) { return o['_id']['name'] })})    
    }
}



function drawSavingsGauge(data) {
    let pct = '-'

    if (typeof data !== 'undefined') {
        const profit = data['profit']
        const income = data['income']

        pct = income == 0 ? '-' : (profit/income*100).toFixed(1)
    }

     const options = {
        chart: {
            height: 150,
            type: 'radialBar',
        },
        series: [pct],
        labels: [""],
        plotOptions: {
            radialBar: {
                dataLabels: {
                    name: {
                        show: false,
                        // offsetY: -10,
                        // color: "#fff",
                        // fontSize: "13px"
                    },
                    value: {
                        // color: "#fff",
                        offsetY: +10,
                        fontSize: "22px",
                        show: true
                    }
                }
            }
        }
    }

    if (typeof globals.vars.charts['apex4'] === 'undefined') {
        globals.vars.charts['apex4'] = new ApexCharts(document.querySelector("#apex-gauge-1"), options)
        globals.vars.charts['apex4'].render()
    } else {
        globals.vars.charts['apex4'].updateOptions(options, true, true, true)  
    }
}


